import React, { Component } from 'react';
import {parameterizedURLAccessToken} from '../../../../Utils/CommonFunctions';
// import Wrp from '../../../hoc/Wrp/Wrp';
// import {getDateFormat} from '../../../../Utils/UserFunctions';
// import moment from 'moment';

class Barcode extends Component {
    
    render () {
        const {colData,id} = this.props;
        // let convertTime;
        const img = colData.value;
        const imgArr =  (Array.isArray(colData.value)===false || colData.value.length===0)?[""]:colData.value;
        const imgUrl = (img!=='' && img!==undefined && img!==null)?parameterizedURLAccessToken('files/download?fileId='+img):'';
        return(
            <td key={id}>
            <div className="item-list" >
				<div className="" style={{marginLeft:'5px'}}>
                {
                    imgUrl !== '' ?
                        <img src={imgUrl} alt="..." className="avatar-img rounded-circle" />
                    : null
                }
				</div>		 
			</div>
            </td>
        );
    }
}

export default Barcode;